// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"f85b62ce","453":"d15f14ad"}[chunkId] + ".chunk.js";
};